import React from "react";

const FaultListGroup: React.FC = () => (
  <svg
    version="1.1"
    id="svg-block-pile"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 96 96"
    fill="#0071B9"
    xmlSpace="preserve"
  >
    <g id="ico-block-pile">
      <rect
        id="dimension"
        style={{ visibility: "hidden", opacity: 0, fill: "#FFFFFF" }}
        width="96"
        height="96"
      />
      <path
        id="icongraphic"
        d="M37,7H15c-4.411,0-8,3.589-8,8v22c0,4.411,3.589,8,8,8h22c4.411,0,8-3.589,8-8V15&#10;&#9;&#9;C45,10.589,41.411,7,37,7z M37,37H15l-0.005-22C15,15,37,15,37,15V37z M81,7H59c-4.411,0-8,3.589-8,8v22c0,4.411,3.589,8,8,8h22&#10;&#9;&#9;c4.411,0,8-3.589,8-8V15C89,10.589,85.411,7,81,7z M81,37H59l-0.005-22C59,15,81,15,81,15V37z M37,51H15c-4.411,0-8,3.589-8,8v22&#10;&#9;&#9;c0,4.411,3.589,8,8,8h22c4.411,0,8-3.589,8-8V59C45,54.589,41.411,51,37,51z M37,81H15l-0.005-22C15,59,37,59,37,59V81z M81,51H59&#10;&#9;&#9;c-4.411,0-8,3.589-8,8v22c0,4.411,3.589,8,8,8h22c4.411,0,8-3.589,8-8V59C89,54.589,85.411,51,81,51z M81,81H59l-0.005-22&#10;&#9;&#9;C59,59,81,59,81,59V81z"
      />
    </g>
  </svg>
);

export default FaultListGroup;
